@if (preferences$ | async; as preferences) {
    @if (assets.length > 0) {
        <div
            class="noselect viewer"
            [style.background]="ColorSwatchMap.get(preferences.viewer_background)"
        >
            @if (assets.length > 1) {
                <div class="left nav-arrow noselect">
                    <a (click)="previous()">
                        <mat-icon [style.margin-top.px]="height / 2">navigate_before</mat-icon>
                    </a>
                </div>
            }
            @if (assets.length > 1) {
                <div class="right nav-arrow noselect">
                    <a (click)="next()">
                        <mat-icon [style.margin-top.px]="height / 2">navigate_next</mat-icon>
                    </a>
                </div>
            }
            <div class="flex row align-items-center justify-stretch actions noselect hoverdisplay">
                <!-- Title/Versions -->
                <div class="flex row justify-start title">
                    <span>{{ assets[index].name }}</span>
                </div>
                <!-- Tools -->
                <div class="flex justify-center tools">
                    @for (tool of tools$ | async; track tool) {
                        <button mat-icon-button (click)="tool.action()" [matTooltip]="tool.tooltip">
                            <mat-icon fontSet="material-icons-outlined">{{ tool.icon }}</mat-icon>
                        </button>
                    }
                    @if (revisions$ | async; as revisions) {
                        @if (revisions.length > 1) {
                            <button mat-button [matMenuTriggerFor]="menu">
                                <mat-icon>layers</mat-icon> v{{ revision || revisions.length }}
                            </button>
                        }
                    }
                </div>
                <!-- Close -->
                <div class="flex justify-end">
                    <button mat-icon-button (click)="close($event)">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
            </div>
            @if (assets[index].asset_type === AssetType.Image) {
                <frog-image
                    #assetViewer
                    [asset]="assets[index]"
                    [preferences]="preferences"
                ></frog-image>
            }
            @if (assets[index].asset_type === AssetType.Video) {
                <frog-video #assetViewer [asset]="assets[index]" class="flex"></frog-video>
            }
            @if (assets[index].asset_type === AssetType.Marmoset) {
                <frog-marmoset #assetViewer [asset]="assets[index]"></frog-marmoset>
            }
            @if (assets[index].asset_type === AssetType.Group) {
                <frog-group
                    #assetViewer
                    [asset]="assets[index]"
                    [preferences]="preferences"
                ></frog-group>
            }
            <mat-menu #menu="matMenu">
                @if (revisions$ | async; as revisions) {
                    @for (revision of revisions; track revision) {
                        <button mat-menu-item (click)="setRevision(revision)">
                            {{ revision.revision + 1 }}
                        </button>
                    }
                }
            </mat-menu>
        </div>
    }
}
